import { Component, OnInit, Input } from '@angular/core';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';
import { AppService } from 'src/app/app.service';
import { ProductService } from 'src/app/services/api/product/product.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { JsonComponent } from 'src/app/core/json/json.component';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {

  appData: any;

  @Input() summary: OrderSummary;

  json: any;
  jsonRef: MatDialogRef<JsonComponent>;

  constructor(private appService: AppService,
    private productService: ProductService, public dialog: MatDialog) {
  }

  ngOnInit() {
    this.appData = this.appService.settings;

    this.productService.getInventoryProduct(this.summary.serviceRef).subscribe(
      data => {
        this.json = data;
        delete this.json._links;
      }
    );

  }

  goToProduct() {
    window.open(`${this.appData.baseUrl}${this.appData.basePath}/provision/products/detail?id=${this.summary.inventoryId}`, '_blank');
  }

  showInventoryProduct() {
    this.jsonRef = this.dialog.open(JsonComponent, {
      data: { title: 'Información del producto en inventario', json: this.json },
      width: '850px'
    });

  }


}
